import { certificate } from '../../api'

const state = {
  certificate: {
    lookupList: [],
    list: [],
    certificateCodeList: [],
    certificateLookupDate: [],
    dueDate: '',
    slideBlock: false,
    detail: {
      certificateIssuanceId: '',
      requestDate: '',
      number: '',
      state: '',
      list: []
    }
  },
  requestData: {
    list: [{
      id: '',
      name: '',
      detail: '',
      price: ''
    }]
  },
  slideBlock: {
    id: '',
    name: '',
    detail: '',
    price: ''
  }
}

const getters = {
  getCertificateList: state => state.certificate.list,
  getSlideBlock: state => state.slideBlock,
  getRequestData: state => state.requestData,
  getCertificateDueDate: state => state.certificate.dueDate,
  getCertificateSlideBlock: state => state.certificate.slideBlock,
  getCertificateLookupList: state => state.certificate.list,
  getCertificateLookupDate: state => state.certificate.certificateLookupDate,
  getCertificateLookupDetail: state => state.certificate.detail
}

const mutations = {
  SET_CERTIFICATE_DATE (state, payload) {
    state.certificate.certificateLookupDate = payload
  },
  SET_CERTIFICATE_LOOKUP_DETAIL (state, payload) {
    state.certificate.detail = payload
  },
  SET_CERTIFICATE_LIST (state, certificate) {
    state.certificate.list = certificate.list
  },
  SET_SLIDE (state, slideBlock) {
    state.slideBlock.id = slideBlock.id
    state.slideBlock.name = slideBlock.name
    state.slideBlock.detail = slideBlock.detail
    state.slideBlock.price = slideBlock.price
  },
  SET_REQUEST (state, requestData) {
    state.requestData = requestData
  },
  SET_CERTIFICATE_DUEDATE (state, certificate) {
    state.certificate.dueDate = certificate.dueDate
    state.certificate.slideBlock = certificate.slideBlock
  },
  SET_CERTIFICATE_LOOKUP (state, certificate) {
    state.certificate.list = certificate.list
  }
}

const actions = {
  CERTIFICATE_LIST ({ commit }) {
    return certificate.certificateList()
      .then((data) => commit('SET_CERTIFICATE_LIST', data.response))
  },
  CERTIFICATE_REQUEST ({ commit }, payload) {
    return certificate.certificateRequest(payload)
      .then((data) => commit('SET_CERTIFICATE_DUEDATE', data.response))
  },
  CERTIFICATE_LOOKUP ({ commit }, payload) {
    return certificate.certificateLookup(payload)
      .then((data) => commit('SET_CERTIFICATE_LOOKUP', data.response))
  },
  CERTIFICATE_LOOKUP_DETAIL ({ commit }, payload) {
    return certificate.certificateLookupDetail(payload)
      .then((data) => commit('SET_CERTIFICATE_LOOKUP_DETAIL', data.response))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
